document.addEventListener('DOMContentLoaded', () => {
  const stickyBar = document.querySelector('[data-sticky-atc]');
  const buyButtons = document.querySelector('.product-form__buttons');
  if (!stickyBar || !buyButtons || !('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const scrolledPast = entry.boundingClientRect.top < 0 && !entry.isIntersecting;
        stickyBar.classList.toggle('sticky-atc--visible', scrolledPast);
      });
    },
    { threshold: 0 }
  );

  observer.observe(buyButtons);
});
